import { SpineSymbolConfig } from "slotworks/config/spine-config-schema";
import canvasManager, { Orientation } from "slotworks/graphics/canvas/canvas-manager";
import ExtendedSpine from "slotworks/graphics/spine/spine";
import spineManager from "slotworks/graphics/spine/spine-manager";
import deviceInfo from "slotworks/utils/device-info";

class SpinePool {

    private map: Map<string, ExtendedSpine[]> = new Map();

    public getSpineSymbol(symbolId: string) {
        let spine;
        if (this.map.has(symbolId)) {
            spine = this.map.get(symbolId).pop();
        } else {
            this.map.set(symbolId, []);
        }
        if (!spine) {
            spine = spineManager.createSpineSymbol(symbolId);
        }
        // TODO update scale in symbol
        const config = (spine as any).config as SpineSymbolConfig;
        if(canvasManager.orientation == Orientation.PORTRAIT) {
            const scale = deviceInfo.widePortrait ? config.portraitV2Scale : config.portraitScale;
            spine.scale.x = spine.scale.y = scale;
        } else {
            spine.scale.x = spine.scale.y = config.landscapeScale;
        }
        return spine;
    }

    public restore(symbolId: string, spine: ExtendedSpine) {
        this.map.get(symbolId).push(spine);
    }


}
export default new SpinePool();